/* unplugin-vue-components disabled */import { render } from "./fujianshifan.vue?vue&type=template&id=79dc4ff7&scoped=true"
import script from "./fujianshifan.vue?vue&type=script&lang=js"
export * from "./fujianshifan.vue?vue&type=script&lang=js"

import "./fujianshifan.vue?vue&type=style&index=0&id=79dc4ff7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79dc4ff7"]])

export default __exports__